export const imageCodes = {
    footer: {
        code: "${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ffoot.png?alt=media&token=fe1c0761-54c5-4dcf-a361-600948b5de29",
    },
}